import React from 'react';

import { PageShellLayout, PageShell } from 'src/styles/pageLayoutStyles';
import styled from 'styled-components';
import { DSAPOCPublicPageConstants } from 'src/constants/ProjectConstants';
import { Section } from 'src/components/LandingPage';
import { DDMContextInjector } from 'src/integration/ddm/hydrator/DDMContextInjector';
import { ScrollRestoration } from 'react-router-dom';
import { DDM_SCHEMA_ID_FOR_PROGRAMS } from 'src/constants/GlobalConstants';
import { CreateCaseFormWithCaptcha } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha';
import { REPORTING_TYPE } from 'src/pages/ExternalLandingPage/components/CreateCaseFormWithCaptcha/CreateCaseFormWithCaptcha';

const TrustContainer = styled.div`
  padding: 2rem 1.5rem 2.5rem 1.5rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.Lake};
`;

const CreateCaseFormContainer = styled.div`
  padding: 0rem 0rem 0rem 0rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.Zircon};
`;

const SuccessModalContainer = styled.div`
  padding: 1rem 0rem 1rem 0rem; /* top right bottom left  */
`;
const SuccessModalBody = ({ successMessage, description }) => {
  return (
    <SuccessModalContainer>
      <h3>{successMessage}</h3>
      {description}
    </SuccessModalContainer>
  );
};

export const LandingPage = () => {
  return (
    <PageShellLayout>
      <PageShell>
        <ScrollRestoration />
        <TrustContainer>
          <Section header={DSAPOCPublicPageConstants.TRUST_SECTION_HEADER}>
            <>{DSAPOCPublicPageConstants.TRUST_SECTION_MESSAGE}</>
          </Section>
        </TrustContainer>
        <CreateCaseFormContainer id="create-case-component">
          <DDMContextInjector schemaKey={DDM_SCHEMA_ID_FOR_PROGRAMS.DSA_POC}>
            <CreateCaseFormWithCaptcha
              reportingType={REPORTING_TYPE.ANONYMOUS}
              successModalBody={
                <SuccessModalBody
                  successMessage={
                    DSAPOCPublicPageConstants.REPORT_AN_ISSUE_SUCCESS_MODAL_TEXT
                  }
                  description={
                    DSAPOCPublicPageConstants.REPORT_AN_ISSUE_SUCCESS_MODAL_MESSAGE
                  }
                />
              }
              allowAttachments={false}
              showReferralInfo={false}
              messages={{
                CREATE_CASE_FAILURE_MESSAGE:
                  DSAPOCPublicPageConstants.REPORT_AN_ISSUE_FAILURE_MODAL_MESSAGE,
                CREATE_CASE_SUCCESSFUL_MODAL_HEADER:
                  DSAPOCPublicPageConstants.REPORT_AN_ISSUE_SUCCESS_MODAL_HEADER,

                CREATE_CASE_SUCCESSFUL_MODAL_BUTTON_CLOSE_LABEL:
                  DSAPOCPublicPageConstants.REPORT_AN_ISSUE_ACTION_BUTTON_LABEL_CLOSE,

                REPORT_A_CASE_HEADER:
                  DSAPOCPublicPageConstants.REPORT_A_CASE_FORM_HEADER,

                REPORT_A_CASE_DESCRIPTION:
                  DSAPOCPublicPageConstants.REPORT_A_CASE_FORM_DESCRIPTION,
                CAPTCHA_TITLE: DSAPOCPublicPageConstants.CAPTCHA_MODAL_TITLE,
              }}
            />
          </DDMContextInjector>
        </CreateCaseFormContainer>
      </PageShell>
    </PageShellLayout>
  );
};
